import React, {Component} from 'react';
import {BeatLoader} from 'react-spinners';
import {Link} from 'react-router-dom';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import {_addNotification, _addNotificationError,isRegularLunchOrderType,getAccessLevelByModule,getModuleEnum} from "../../../../server/util";
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {Line} from 'react-chartjs-2';
import { BASE_URL_1,MenuOrderTypes,MealTypesReports,MealTypes } from '../../../../server/constants';
import {getReportMenuOptions} from '../../../Misc/MenuOptions/menuOptionsActions';
import RadioMenu from '../../../Misc/MenuOptions/radioMenu'; 
import { endsWith } from 'lodash';

var _ = require('lodash');
const options={
    responsive: true,
    maintainAspectRatio: false,
    legend:{
        position:'top'
    },
    scales: {
        xAxes: [{
                ticks: {
                 fontSize: 9,
                 min:0
                }
               }],
        yAxes: [{
                ticks: {
                 fontSize: 9,
                 min:0
                }
               }]

             },
             plugins: {
               datalabels: {
                  display: true,
                  align:'bottom',
                  font: { size: '10',weight: 'bold' }
               }
            }
}
const modEnum=getModuleEnum();
class OrderLine extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            currentIndex:0,
            schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList')),
           /*  mealType: (getAccessLevelByModule(modEnum.LMCU)|| getAccessLevelByModule(modEnum.LMCI)? MealTypesReports.LUNCH:
            (getAccessLevelByModule(modEnum.SMCU)|| getAccessLevelByModule(modEnum.SMCI))? MealTypesReports.SNACK:null), */
            mealType:(getReportMenuOptions()[0]||''),
            sid: 0,
            lineChart : {
                labels: [],
                datasets: [
                  {
                    label: 'Orders count',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgb(87, 208, 200)',
                    borderColor: 'rgb(87, 208, 200)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgb(87, 208, 200)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 5,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgb(87, 208, 200)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: [],
                  }
                ]
              }
        }
        this.initCurrentIndex=this.initCurrentIndex.bind(this)
        this.onChangeSchoolYear=this.onChangeSchoolYear.bind(this);
        this.getOrdersData=this.getOrdersData.bind(this);
    }
    
    componentWillMount=()=>{
        this.initCurrentIndex();

    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.props.schoolYear!=''){  
            this.setState({schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList'))},()=>{
                this.initCurrentIndex(); 

            })
                   
        }
    }

    initCurrentIndex=()=>{
        let stateObj=this.state;
       let index= _.findIndex(stateObj.schoolYearList, function(sYear) { return sYear.schoolYear == sessionStorage.getItem('schoolYearValue') });
       this.setState({currentIndex:index},()=>{
        this.onChangeSchoolYear();
    })
    }
    onChangeSchoolYear=()=>{
        //console.log(this.state.currentIndex)
        /* let currentSession=this.state.schoolYearList[this.state.currentIndex];
        let dateStart = moment(currentSession.sessionStartDateTime);
        let dateEnd = moment(currentSession.sessionEndDateTime);
        let MonthsList = [];

        while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
            MonthsList.push(dateStart.format('YYYY-MMM'));
            dateStart.add(1,'month');
        }
        console.log('Months :',MonthsList) */
        this.getOrdersData()

    }
    getOrdersData=()=>{
        let currentSession=this.state.currentIndex==-1?undefined:this.state.schoolYearList[this.state.currentIndex];
        if(this.state.mealType===MealTypesReports.LUNCH ||
            this.state.mealType===MealTypesReports.SNACK){
        //const mType=(this.state.mealType===MealTypesReports.LUNCH) &&!isRegularLunchOrderType()?MenuOrderTypes.ITEMIZE:this.state.mealType;
        if(currentSession!=undefined){
        let dateStart = moment(currentSession.sessionStartDateTime).format('YYYYMM');
        let dateEnd = moment(currentSession.sessionEndDateTime).format('YYYYMM');        
        get('/dashboard/ordersCountByMonth?mealSchoolId=' + sessionStorage.getItem('SchoolId')+ '&menuType='+ this.state.mealType  + '&yearMonthStart=' + dateStart + '&yearMonthEnd=' + dateEnd + '&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _lineChart=this.state.lineChart;
            _lineChart.labels=[];
            _lineChart.datasets[0].data=[];
            Object.keys(orders).map((key)=>{
                _lineChart.labels.push(moment(key.substr(0,4)+'-'+key.substr(4,key.length-1)).format('MMM-YY'));
                _lineChart.datasets[0].data.push(orders[key]);
            })
            this.setState({ lineChart:_lineChart,loading: false          
            })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
        }}
    }
    render(){
        let schoolSessionYear= this.state.schoolYearList==null?'':
        (this.state.schoolYearList[this.state.currentIndex==-1?0: this.state.currentIndex].name)
        return(<div>
         <NotificationSystem ref="notificationSystem"/> 
         <div className="col-md-4">  
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>   
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                
                   {/*  <div> */}
                <span className="panel-title  " 
                style={{fontSize: '14px', fontWeight:'600'}}>
                 {'Orders Trend' }</span>
               
               {/*  <RadioMenu radioMenuList={getReportMenuOptions()} onOptionSelect={(type)=>{
                                          this.setState({mealType:type},()=>{
                                            this.getOrdersData();
                                          })
                                    }}   selectedOption={(this.state.mealType)}  /> */}
                                   
                                    {/* </div> */}
                                    <div className="pull-right">
            
                {
                    this.state.currentIndex>0?<a href='javascript:void(0)'  className="btn-lt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex-1)<0?0:(cIndex-1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }}><i className='fa fa-chevron-circle-left '></i></a>: <a className="btn-lt" disabled="disabled"><i className='fa fa-chevron-circle-left '></i></a>
                }
                {
                    this.state.currentIndex<(this.state.schoolYearList==null?[]:this.state.schoolYearList).length-1?<a href='javascript:void(0)' className="btn-gt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex+1)>this.state.schoolYearList.length-1?this.state.schoolYearList.length-1:(cIndex+1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }} ><i className='fa fa-chevron-circle-right'></i></a>:<a className="btn-gt" disabled="disabled"><i className='fa fa-chevron-circle-right'></i></a>
                }   
                </div>
               <div>
                <p className="panel-title" 
                style={{fontSize: '12px', fontWeight:'600',/* marginRight:'28%' textAlign:'end'*/}}>
                 {'[School Year: '+schoolSessionYear +']' }</p>
                 </div>
                
                 
                {/*  {
                            (getAccessLevelByModule(modEnum.LMCU,this.state.sid) || getAccessLevelByModule(modEnum.LMCI,this.state.sid))?
                            <div className="styled-input-single pull-right col-sm-2">
                                <input type="checkbox" name="mealType" id={'rb'+MealTypes.LUNCH} onChange={()=>{
                                    this.setState({mealType:MealTypes.LUNCH})
                                }} checked={false} checked={this.state.mealType===MealTypes.LUNCH} />
                                <label htmlFor={'rb'+MealTypes.LUNCH}>{MealTypes.LUNCH}</label>
                            </div>:null
                        } */}
            </div>
            <div className="panel-body" style={{padding:'0px'}}>  
                  
            <Line data={this.state.lineChart} options={options} onElementsClick={(elems)=>{
                if(elems.length>0){
                        console.log(elems[0]._datasetIndex + ', ' + elems[0]._index);
                        let grade= '0';
                        let action= 'Ordered';
                        let selectedMonthYear=moment(this.state.lineChart.labels[elems[0]._index],'MMM-YY').format('YYYYMM');
                        this.props.onElementClick(grade,action,selectedMonthYear)
                     } 
            }} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default OrderLine


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/orderLine.jsx